var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCafes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 117 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16319 4.08159H85.7135C87.9677 4.08159 89.7951 5.90899 89.7951 8.16319V69.3871C89.7951 80.6581 80.6581 89.7951 69.3871 89.7951H24.4896C13.2186 89.7951 4.08159 80.6581 4.08159 69.3871V8.16319C4.08159 5.90899 5.90899 4.08159 8.16319 4.08159Z",
    stroke: "white",
    strokeWidth: 8.16319
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7949 20.4072C102.04 16.3265 120.407 46.9389 91.8357 61.2238",
    stroke: "white",
    strokeWidth: 4.08159
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7949 12.2461C112.244 10.205 130.611 55.1032 89.7949 69.3884",
    stroke: "white",
    strokeWidth: 4.08159
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6626 33.9039C63.7753 38.1984 51.2375 35.1437 41.9331 30.3782C36.3853 27.5367 29.4551 27.1966 24.4903 30.9654L18.4775 35.4782L80.8096 37.676C80.8096 34.5123 76.5644 32.6435 73.6626 33.9039Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4.15547
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2461 37.3828H82.8891V66.6315C82.8891 74.9158 76.1734 81.6315 67.8891 81.6315H27.2461C18.9618 81.6315 12.2461 74.9158 12.2461 66.6315V37.3828Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCafes);
export default __webpack_public_path__ + "static/media/cafes.2608c582f6db1a41bcb82e81b6747080.svg";
export { ForwardRef as ReactComponent };